import { Fund } from "../types"

export function findFund(funds: Fund[], id: Fund["id"]): Fund | undefined {
  return funds.find((f) => f.id === id)
}
